import classNames from 'classnames';
import * as React from 'react';
import styles from './RankWrapper.module.scss.js';

var RankWrapper = React.memo(function (props) {
    return React.createElement("div", { className: classNames(styles["level-" + props.level], props.className) }, props.children);
});

export { RankWrapper as default };
//# sourceMappingURL=RankWrapper.js.map
